'use strict';

/* globals config */

require([
	config.relative_path + '/plugins/nodebb-plugin-courses/static/vendor/vue.js',
	'coverPhoto',
	'pictureCropper',
], function (Vue, coverPhoto, pictureCropper) {
	var internals = {};

	Vue.component('chapter-edit', {
		props: ['chapter', 'index', 'removeChapter', 'up', 'down', 'initData'],
		data: function () {
			return {
				accordion: 'chapter' + this.index,
				accordionHref: '#chapter' + this.index,
				heading: 'heading' + this.index,
			};
		},
		mounted: function () {
			this.chapter.el = this.$el;
		},
		methods: {
			selectImage: function () {
				var me = this;

				internals.openSelectImage(function (imageUrl) {
					me.$set(me.chapter, 'footerImage', imageUrl);

					me.saveFilePermissions(imageUrl);
				});
			},
			removeImage: function () {
				this.chapter.footerImage = null;
			},
		},
		template:
			'<div class="panel panel-default">' +
				'<div class="panel-heading" role="tab" :id="heading">' +
					'<h4 class="panel-title">' +
						'<a role="button" data-toggle="collapse" data-parent="#chapters" :href="accordionHref" aria-expanded="false" :aria-controls="accordion">' +
							'Chapter: {{chapter.title}}' +
						'</a>' +
						'<button type="button" v-on:click="removeChapter(chapter)" class="btn btn-xs btn-danger pull-right">{{initData.translations.removeChapter}}</button>' +
						'<button type="button" v-on:click="up(chapter)" class="btn btn-xs btn-primary pull-right mr-2"><i class="fa fa-arrow-up" aria-hidden="true"></i></button>' +
						'<button type="button" v-on:click="down(chapter)" class="btn btn-xs btn-primary pull-right mr-2"><i class="fa fa-arrow-down" aria-hidden="true"></i></button>' +
					'</h4>' +
				'</div>' +
				'<div :id="accordion" class="panel-collapse collapse" role="tabpanel" :aria-labelledby="heading">' +
					'<div class="panel-body">' +
						'<div class="row">' +
							'<div class="col-md-8">' +
								'<label for="name">{{initData.translations.title}}</label>' +
								'<input type="text" class="form-control" v-model="chapter.title" :placeholder="initData.translations.titlePlaceholder" />' +
							'</div>' +
							'<div class="col-md-8">' +
								'<label for="name">{{initData.translations.description}}</label>' +
								'<textarea class="form-control" v-model="chapter.description" rows="5" :placeholder="initData.translations.descriptionPlaceholder"></textarea>' +
							'</div>' +
						'</div>' +
						'<div class="fg-line mt-3 mb-3">' +
							'<label for="name">{{initData.translations.video}}</label>' +
							'<creator-edit-video class="mb-2" :video-container="chapter" :init-data="initData"></creator-edit-video>' +
						'</div>' +
						'<div class="row">' +
							'<div class="col-md-8">' +
								'<div class="row" v-if="chapter.footerImage">' +
									'<div class="col-lg-6 col-md-8 col-sm-12">' +
										'<img :src="chapter.footerImage" alt="" style="width: 100%" />' +
									'</div>' +
								'</div>' +
								'<button v-if="chapter.footerImage" class="btn btn-danger" type="button" v-on:click="removeImage()">' +
									'{{initData.translations.removeImage}}' +
								'</button>' +
								'<button v-if="!chapter.footerImage" class="btn btn-primary" type="button" v-on:click="selectImage()">' +
									'<i class="fa fa-picture-o" aria-hidden="true"></i> {{initData.translations.addImage}}' +
								'</button>' +
							'</div>' +
							'<div class="col-md-8">' +
								'<label for="name">{{initData.translations.footerText}}</label>' +
								'<textarea class="form-control" v-model="chapter.footerText" rows="5" :placeholder="initData.translations.footerTextPlaceholder"></textarea>' +
							'</div>' +
						'</div>' +
					'</div>' +
				'</div>' +
			'</div>',
	});

	internals.openSelectImage = function (onSuccess) {
		pictureCropper.show({
			title: '[[ideas-board:select-image]]',
			socketMethod: 'plugins.courses.uploadPicture',
			aspectRatio: NaN,
			allowSkippingCrop: true,
			restrictImageDimension: false,
		}, onSuccess);
	};
});
